import { render } from "./AppNavigationCarets.vue?vue&type=template&id=3035cb30&scoped=true&bindings={\"navigate\":\"props\",\"allResolution\":\"props\",\"uid\":\"props\",\"hide\":\"props\"}"
import script from "./AppNavigationCarets.vue?vue&type=script&lang=js"
export * from "./AppNavigationCarets.vue?vue&type=script&lang=js"

import "./AppNavigationCarets.vue?vue&type=style&index=0&id=3035cb30&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-3035cb30"

export default script